import { useEffect, useState } from "react";
import API from "../../../services/api";
import { useNavigate } from "react-router-dom";
import "./exam.css";

export default function ArchivedExams() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadArchived = async () => {
    try {
      setLoading(true);
      const res = await API.get("/school-admin/exams/archived/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setExams(res.data.exams || []);
    } catch (err) {
      console.error(err);
      alert("Error loading archived exams");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadArchived();
    // eslint-disable-next-line
  }, []);

  const restoreExam = async (id) => {
    if (!window.confirm("Restore this exam?")) return;

    await API.post(
      `/school-admin/exams/restore/${id}/`,
      {},
      { headers: { "X-SCHOOL-ID": school.school.id } }
    );

    loadArchived();
  };

  return (
    <div className="exam-container">
      <div className="page-header">
        <div>
          <h2 className="page-title">Archived Exams</h2>
          <p className="page-subtitle">
            Restore previous exam schedules when they are needed again.
          </p>
        </div>

        <button
          className="btn-primary"
          onClick={() => navigate("/school-admin/exams")}
        >
          ← Back to Exams
        </button>
      </div>

      <table className="styled-table">
        <thead>
          <tr>
            <th>Exam</th>
            <th>Subject</th>
            <th>Date</th>
            <th>Class</th>
            <th>Section</th>
            <th>Archived On</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan="7" className="no-data">Loading archived exams...</td>
            </tr>
          ) : exams.length === 0 ? (
            <tr>
              <td colSpan="7" className="no-data">No archived exams</td>
            </tr>
          ) : (
            exams.map((e) => (
              <tr key={e.id}>
                <td>{e.name}</td>
                <td>{e.subject || "-"}</td>
                <td>{e.date}</td>
                <td>{e.class_name || "-"}</td>
                <td>{e.section_name || "-"}</td>
                <td>{e.archived_at || "-"}</td>
                <td>
                  <button
                    className="btn-ghost-success"
                    onClick={() => restoreExam(e.id)}
                  >
                    Restore
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
